import { toast } from '@medusajs/ui'
import { AxiosError } from 'axios'
import { HTTPError as KyError } from 'ky'
import type { FieldErrors } from 'react-hook-form'

import { ApiError } from '@/features/api'

import { queryClient } from '@/lib/tanstack-query'

export async function invalidateQueries(keys: string[], qc = queryClient) {
  const keySet = new Set(keys)
  await qc.invalidateQueries({
    predicate: query => {
      const hasMatch = keySet.has(query.queryKey[0] as string)
      if (hasMatch) console.log('invalidate', query.queryKey[0])
      return hasMatch
    },
    type: 'all',
    refetchType: 'all',
  })
}

export function handleApiError(error: Error) {
  let axiosError: AxiosError | undefined = undefined
  let kyError: KyError | undefined = undefined

  if (error instanceof AxiosError) {
    axiosError = error
  } else if (error instanceof KyError) {
    kyError = error
  } else {
    console.error(error)
  }

  return {
    isAxiosError: !!axiosError,
    getKyError: () => kyError!,
    getCode<T extends string = string>(): T {
      let code: string = undefined!
      code = (axiosError?.response?.data as any)?.code || 'UNKNOWN'
      return code as T
    },
    getMessage() {
      return (axiosError?.response?.data as any)?.msg || error.message || 'Unknown error'
    },
  }
}

export function handleApiErrorToastMsg(fallback = 'Unknown error') {
  return (error: Error): { title: string; description?: string } => {
    const _err = handleApiError(error).getKyError()
    return {
      title: _err?.response?.statusText || fallback,
      description: _err?.request.url,
    }
  }
}

export function handleSubmitFormError(error: Error | FieldErrors) {
  let msg = 'Form error'
  if (error instanceof Error) {
    msg = error.message
  }

  console.error(error)

  toast.error(msg, {
    id: 'form-error',
    dismissable: true,
    description: (
      <div className='max-w-full overflow-auto'>
        <pre>{JSON.stringify(error, null, 2)}</pre>
      </div>
    ),
  })
}

export function handleApiErrorWithToast(defaultMsg = 'Unknown error') {
  return (error: unknown) => {
    if (error instanceof ApiError) {
      return {
        title: error.raw.response?.statusText || defaultMsg,
        description: error.getData()?.msg || error.raw.message || defaultMsg,
      }
    } else if (error instanceof Error) {
      return {
        title: error.message || defaultMsg,
      }
    } else {
      console.error("Can't handle error", error)
      return {
        title: defaultMsg,
      }
    }
  }
}
